/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { BusinessType } from 'app/shared/model/enumerations/business-type.model';

export interface IFacilityLocation {
  id?: string;
  active?: boolean | null;
  revoked?: boolean | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  facilityType?: keyof typeof EntityType | null;
  facilityId?: string | null;
  locationType?: keyof typeof EntityType | null;
  locationId?: string | null;
  businessType?: keyof typeof BusinessType | null;
}

export const defaultValue: Readonly<IFacilityLocation> = {
  active: false,
  revoked: false,
};
